// extracted by mini-css-extract-plugin
export default {"container":"PujZ978EclAqxtXsyFEqNA==","deleteButton":"_3GLu8yDxqkJJByR6kFp8UA=="};